import { createQueryKeys } from '@lukemorales/query-key-factory';
import { type MaybeRefOrGetter, toValue } from 'vue';

import { getUser, getUsers } from '../api';

export const usersKeys = createQueryKeys('users', {
  user: (userUuid: MaybeRefOrGetter<string>) => ({
    queryKey: [userUuid],
    queryFn: (options) => getUser(toValue(userUuid), options),
  }),
  users: {
    queryKey: null,
    queryFn: (options) => getUsers(options),
  },
});
